import type { ReactElement } from 'react';
import { ChatButton, ChatDialogEvent } from 'sdk';

import { useSDK } from '../../../../app';
import { Button } from './button';

export const SelectionButton = ({
	message,
	button,
}: {
	message: ChatDialogEvent;
	button: ChatButton;
}): ReactElement => {
	const { formsStore, eventsStore } = useSDK();
	return (
		<Button
			disabled={false}
			onClick={(): void => {
				eventsStore.hideEvent(message.id);
				formsStore.sendSelectedButton(button.key, button.value);
			}}
			value={button.value}
		/>
	);
};
